import React, {Component} from 'react';

export default class ContactForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            message:""
        };
    }

    render() {
        return (
            <form className="mail-form" onSubmit={()=>this.props.callback(this.state)}>
                <input type="email" placeholder="Email:" value={this.state.email} onChange={(event)=>this.setState({email:event.target.value})} required/>
                <textarea placeholder="Mensaje:" value={this.state.message} onChange={(event)=>this.setState({message:event.target.value})} required rows="4"/>
                <button type="submit" className="button style-5 uppercase">send</button>
            </form>
        );
    }

}



// WEBPACK FOOTER //
// ./src/visitors/components/ContactForm.js